import React, { Component, Fragment } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";

import Locale from './Entities/Locale.js';

import Homepage from './Pages/Homepage.js';
import Upload from './Pages/Upload.js';
import Translate from './Pages/Translate.js';
import Validate from './Pages/Validate.js';
import Login from './Pages/Login.js';
import EditUsers from './Pages/EditUsers.js';
import EditMaster from './Pages/EditMaster.js';
import EditLocales from './Pages/EditLocales.js';
import UseToken from './Pages/UseToken.js';
import ForgotPassword from './Pages/ForgotPassword.js';

import LocalesProvider, { LocalesContextConsumer, withLocales } from './Providers/LocalesProvider.js';
import { withApi, WebServiceContextConsumer } from './Providers/WebServiceProvider.js';
import ability from './abilities';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <WebServiceContextConsumer>
    {
      context =>
        <Route
          {...rest}
          render={props => 
            {
              if (! context.auth.getUser()) {
                return (<Redirect to={{pathname: "/login", state: { from: props.location }}} />);
              } else {
                const permission = rest.permission;

                if (permission && 'action' in permission && 'entity' in permission) 
                {
                  const locale = ('key' in permission) ? new Locale({ key: props.match.params[permission.key] }) : permission;
                  let authorized = false;

                  if (Array.isArray(permission.action))
                  {
                    Array.from(permission.action).forEach((p) => {
                      if (ability.can(p, locale)) {
                        authorized = true;
                      }
                    });
                  }
                  else
                  {
                    authorized = ability.can(permission.action, locale);
                  }
                    
                  if (authorized) {
                    return (<Component {...props} />);
                  } else {
                    return (<Redirect to={{pathname: "/", state: { from: props.location }}} />);
                  }
                } else {
                  return (<Component {...props} />);
                }
              }
            }
          }
        />
    }
  </WebServiceContextConsumer>
);

const GuestRoute = ({ component: Component, ...rest }) => (
  <WebServiceContextConsumer>
    {
      context =>
        <Route
          {...rest}
          render={props =>
            context.auth.getUser() 
              ? (<Redirect to={{pathname: "/", state: { from: props.location }}} />) 
              : (<Component {...props} />)
          }
        />
    }
  </WebServiceContextConsumer>
);

class Content extends Component
{
	render () {
		return (
      <Switch>
        <PrivateRoute exact path="/" component={Homepage} />
        <GuestRoute path="/login" component={Login} />
        <GuestRoute path="/reset-password" component={ForgotPassword} />
        <GuestRoute path="/single-use-token/:type/:token" component={UseToken} />
        <PrivateRoute path="/master" component={EditMaster} permission={{action: 'update', entity: 'master' }} />
        <PrivateRoute path="/locales" component={EditLocales} permission={{action: 'update', entity: 'locales' }} />
        <PrivateRoute path="/upload" component={Upload} permission={{action: 'update', entity: 'master' }} />
        <PrivateRoute path="/users" component={EditUsers} permission={{action: 'manage', entity: 'all' }} />
        <PrivateRoute path="/translate/:locale" component={Translate} permission={{action: ['read', 'translate'], entity: 'locales', key: 'locale' }} />
        <PrivateRoute path="/validate/:locale" component={Validate} permission={{action: 'validate', entity: 'locales', key: 'locale' }} />
      </Switch>
		);
	}
}

export default Content;


// WEBPACK FOOTER //
// ./src/Content.js